// AgentDropdown.tsx
import React from "react";
import { Spinner } from "@chakra-ui/spinner";

const AgentDropdown = ({ isDisabled, newUser, handleInputChange, agents }: any) => {
  const handleOptionClick = (event: React.ChangeEvent<HTMLSelectElement>) => {
    handleInputChange({
      target: { name: "agent", value: event.target.value },
    });
  };

  return (
    <div>
      <select
        id="agent"
        name="agent"
        value={newUser.agent}
        onChange={handleOptionClick}
        className="text-navy-700 font-medium text-sm h-10 rounded-md  custom-select relative bg-white border border-gray-300 focus:outline-none py-2 pl-3 pr-10 sm:text-sm w-full shadow-sm"
        disabled={agents === null || agents.length === 0 || isDisabled}
      >
        {agents === null ? (
          <option>Retreiving...</option>
        ) : agents.length === 0 ? (
          <option>Retreiving...</option>
        ) : (
          <>
            {agents.map((agent: any) => (
              <option key={agent.id} value={agent.id}>
                {agent.name}
              </option>
            ))}
          </>
        )}
      </select>
      {agents === null && (
        <div className="mt-2 flex justify-center">
          <Spinner size="sm" />
        </div>
      )}
    </div>
  );
};

export default AgentDropdown;
